"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEnrichWithAssociations = void 0;
var core_1 = require("@newfront-insurance/core");
var dod_api_1 = require("@newfront-insurance/dod-api");
var next_notifications_1 = require("@newfront-insurance/next-notifications");
var react_1 = require("react");
var object_references_1 = require("../bff/lib/object-references");
var enrich_file_results_with_associations_1 = require("../lib/enrich-file-results-with-associations");
var use_files_api_1 = require("./use-files-api");
function useEnrichWithAssociations() {
    var _a = (0, react_1.useState)(false), loading = _a[0], setLoading = _a[1];
    var _b = (0, react_1.useState)(), error = _b[0], setError = _b[1];
    var notifications = (0, next_notifications_1.useNotifications)();
    var filesApi = (0, use_files_api_1.useFilesApi)();
    function enrichWithAssociations(fileResults, exclusion) {
        return __awaiter(this, void 0, void 0, function () {
            var response, objectReferences, mergedObjectReferences, resolvedAssociations, associations, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        setError(undefined);
                        response = fileResults;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        objectReferences = (0, object_references_1.flattenObjectReferences)(fileResults, exclusion);
                        mergedObjectReferences = object_references_1.mergeObjectReferences.apply(void 0, objectReferences);
                        return [4 /*yield*/, filesApi.getAssociations(mergedObjectReferences)];
                    case 2:
                        resolvedAssociations = _a.sent();
                        associations = (0, core_1.toMap)(resolvedAssociations, function (association) { return (0, dod_api_1.hashDomainObjectIndex)(association); });
                        // enrich FileResult[] with associations
                        response = (0, enrich_file_results_with_associations_1.enrichResultsWithAssociations)(fileResults, associations);
                        return [3 /*break*/, 5];
                    case 3:
                        e_1 = _a.sent();
                        setError(e_1);
                        notifications.addById('use-enrich-with-associations', {
                            title: "There was a problem enriching file results with associations. ".concat(e_1),
                            type: 'error',
                        });
                        return [3 /*break*/, 5];
                    case 4:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/, response];
                }
            });
        });
    }
    return [(0, react_1.useCallback)(enrichWithAssociations, [filesApi, notifications]), loading, error];
}
exports.useEnrichWithAssociations = useEnrichWithAssociations;
